import http from "@/axios/http-common";

export type SuketTabSource = {
  key: string;
  keys?: string[];
  fetch: ((reg: string, uid?: any) => void) | null;
};

export const bySuket = (key: string, store: any): SuketTabSource => ({
  key,
  fetch: r => store.getSuketByRegister(r)
});

export const byRegister = (key: string, store: any): SuketTabSource => ({
  key,
  fetch: r => store.getByRegister(r)
});

export const byKeys = (keys: string[]): SuketTabSource => ({
  key: keys[0],
  keys,
  fetch: null
});

export const childFetches = (key: string): SuketTabSource => ({
  key,
  fetch: null
});

export default {
  async getByRegister(
    register: string | number
  ): Promise<Record<string, number>> {
    try {
      const resp = await http.getData(`/register/${register}/suket-index`);
      return (resp && resp.data && resp.data.data) || {};
    } catch (e) {
      return {};
    }
  }
};
